import { fetchRegionMarkets, fetchRegions } from "../../api"
import { queryCache, useQuery } from "react-query"
import { Link } from "components/Link"
import { RegionType } from "../../types"
import { compactSmall } from "../../helpers/formatters"
import { cx } from "@emotion/css"
import { mapMarkerStyles } from "../../styles"
import { useI18n } from "providers/I18n"
import { useRevenueParams } from "../../hooks/useRevenueParams"

export const MarkersRenderer = () => {
  const { t } = useI18n()
  const { search, globalEnabled, regionEnabled } = useRevenueParams()
  const updatedUrl = new URLSearchParams(search)
  const updatedUrlMarket = new URLSearchParams(search)

  // depending on params enable the proper data source
  const regionsEnabled = globalEnabled
  const marketsEnabled = regionEnabled

  // regions
  const { data: regionMarkers } = useQuery(["regions", search], fetchRegions, {
    enabled: !!search,
    refetchOnMount: !queryCache.getQueryData(["regions", search]),
  })

  // markets
  const { data: marketMarkers } = useQuery(
    ["markets", search],
    fetchRegionMarkets,
    {
      enabled: !!search,
      refetchOnMount: !queryCache.getQueryData(["markets", search]),
    },
  )

  const markers = regionsEnabled
    ? regionMarkers || []
    : marketsEnabled
      ? marketMarkers?.markets || []
      : []

  const validMarkers = markers.filter(
    (m: { lat?: string; lng?: string }) =>
      m.lat && !isNaN(parseFloat(m.lat)) && m.lng && !isNaN(parseFloat(m.lng)),
  )

  return validMarkers.map((marker: RegionType) => {
    updatedUrl.set("region", marker.name)
    updatedUrlMarket.set("market", marker.name)
    return {
      link: "",
      title: marker.name,
      lat: marker.lat,
      lng: marker.lng,
      body: (
        <>
          {globalEnabled ? (
            <Link
              to={{ pathname: `revenue`, search: updatedUrl.toString() }}
              className={cx("HeadingH5Bold", mapMarkerStyles.popupLink)}
            >
              <div className={cx("HeadingH5Bold", mapMarkerStyles.popupTitle)}>
                {marker?.name}
              </div>
            </Link>
          ) : (
            <Link
              to={{ pathname: `revenue`, search: updatedUrlMarket.toString() }}
              className={cx("HeadingH5Bold", mapMarkerStyles.popupLink)}
            >
              <div className={cx("HeadingH5Bold", mapMarkerStyles.popupTitle)}>
                {marker?.name}
              </div>
            </Link>
          )}
          <div className={mapMarkerStyles.popupBody}>
            <span className={cx("BodyBody1Bold", mapMarkerStyles.popupDetail)}>
              {t("revenue.revenue")}:{" "}
            </span>
            <span
              className={cx("BodyBody1Regular", mapMarkerStyles.popupNumber)}
            >
              ${compactSmall(marker?.economicalData?.revenue)}
            </span>
            <br />
            <span className={cx("BodyBody1Bold", mapMarkerStyles.popupDetail)}>
              {t("revenue.revenuegrowthyoy")}:{" "}
            </span>
            <span
              className={cx("BodyBody1Regular", mapMarkerStyles.popupNumber)}
            >
              {compactSmall(marker?.economicalData?.growth)}%
            </span>
            <br />
            <span className={cx("BodyBody1Bold", mapMarkerStyles.popupDetail)}>
              {!regionEnabled ? t("revenue.oibia") : t("revenue.margin")}:{" "}
            </span>
            <span
              className={cx("BodyBody1Regular", mapMarkerStyles.popupNumber)}
            >
              $
              {marker?.economicalData?.margin?.value
                ? compactSmall(marker?.economicalData?.margin?.value)
                : "N/A"}
            </span>
            <br />
            <span className={cx("BodyBody1Bold", mapMarkerStyles.popupDetail)}>
              {t("revenue.margin")}:{" "}
            </span>
            <span
              className={cx("BodyBody1Regular", mapMarkerStyles.popupNumber)}
            >
              {!isNaN(marker?.economicalData?.margin?.percentage) &&
                compactSmall(marker?.economicalData?.margin?.percentage)}
              %
            </span>
          </div>
        </>
      ),
    }
  })
}
